export const toPgn = (san: readonly string[]): string =>
  san.reduce((pgn, move, index) => {
    const isWhiteMove = index % 2 === 0
    const separator = pgn === '' ? '' : ' '
    const moveNumber = isWhiteMove ? `${index / 2 + 1}. ` : ''
    return `${pgn}${separator}${moveNumber}${move}`
  }, '')

export const moveNumberLabel = (san: string, ply: number): string =>
  ply % 2 === 1 ? `${(ply + 1) / 2}. ${san}` : `${ply / 2}… ${san}`

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
